"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailValidationWrapper = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const common_components_1 = require("@as-react/common-components");
const i18nConstants_1 = require("../../constants/i18nConstants");
const formik_1 = require("formik");
const react_1 = require("react");
const react_i18next_1 = require("react-i18next");
const EmailChangeHandler_1 = require("./EmailChangeHandler");
const EmailValidationUtil_1 = require("./EmailValidationUtil");
const FormValidationUtil_1 = tslib_1.__importDefault(require("../../util/FormValidationUtil"));
const cotopaxi_1 = require("@as/cotopaxi");
const Yup = tslib_1.__importStar(require("yup"));
const EmailError_1 = require("./EmailError");
const common_types_1 = require("@as-react/common-types");
const EmailValidationWrapper = ({ emailFieldKey, checkExists, errorMessages, sendEmail, isCollapsedForm = false, children, setIsCollapsedForm, skipValidationFor, }) => {
    var _a;
    const { values, errors, setFieldValue, isSubmitting, status, setStatus } = (0, formik_1.useFormikContext)();
    const emailValue = (0, formik_1.getIn)(values, emailFieldKey);
    const emailError = (0, formik_1.getIn)(errors, emailFieldKey);
    const emailValuePrev = (0, cotopaxi_1.usePrevious)(emailValue);
    const isEqualValue = emailValue === emailValuePrev;
    const validatedEmail = (0, react_1.useRef)(null);
    const { t } = (0, react_i18next_1.useTranslation)(i18nConstants_1.I18N_NAMESPACES.buy);
    const [suggestedEmail, setSuggestedEmail] = (0, react_1.useState)();
    const [emailStatus, setEmailStatus] = (0, react_1.useState)(undefined);
    const [skipEmailValidation, setSkipEmailValidation] = (0, react_1.useState)(Boolean(skipValidationFor && skipValidationFor === emailValue));
    const { defaultRequestParams, servicesEndpoint } = (0, common_components_1.useAemConfig)();
    const requiredMessage = (_a = errorMessages.required) !== null && _a !== void 0 ? _a : t('buy:buy.login.email.error.required');
    (0, react_1.useEffect)(() => {
        setStatus(Object.assign(Object.assign({}, status), { emailError: emailError }));
    }, [emailError]);
    const validateEmailCallback = (0, react_1.useCallback)((0, EmailValidationUtil_1.validateEmail)(servicesEndpoint, skipEmailValidation, emailStatus, setSuggestedEmail, setEmailStatus, true, skipValidationFor), [skipEmailValidation, emailStatus, skipValidationFor]);
    const schema = Yup.string()
        .when('$regularCheck', ([regularCheck], tmpSchema) => regularCheck
        ? tmpSchema.required(requiredMessage).matches(FormValidationUtil_1.default.emailPatternRegex, errorMessages.invalidEmail)
        : tmpSchema)
        .when('$backendEmailValidationEnabled', ([backendValidation], tmpSchema) => backendValidation ? tmpSchema.test(validateEmailCallback).required(requiredMessage) : tmpSchema)
        .when('$checkExists', ([contextCheckExists], tmpSchema) => contextCheckExists
        ? tmpSchema
            .test((0, EmailValidationUtil_1.validateEmailExists)(servicesEndpoint, defaultRequestParams, errorMessages, true, true, sendEmail, setIsCollapsedForm))
            .required(requiredMessage)
        : tmpSchema)
        .when('$checkExistsWithValidation', ([checkExistsWithValidation], tmpSchema) => checkExistsWithValidation
        ? tmpSchema
            .test((0, EmailValidationUtil_1.validateEmailExists)(servicesEndpoint, defaultRequestParams, errorMessages, true, true, sendEmail, setIsCollapsedForm, true, skipEmailValidation, emailStatus, setSuggestedEmail, setEmailStatus))
            .required(requiredMessage)
        : tmpSchema);
    const handleEmailValidation = (shouldCheckExists) => (email) => {
        if ((status === null || status === void 0 ? void 0 : status.currentFocusField) !== emailFieldKey && email === validatedEmail.current) {
            return status === null || status === void 0 ? void 0 : status.emailError;
        }
        validatedEmail.current = email;
        const backendEmailValidationEnabledContext = !(shouldCheckExists && checkExists);
        const checkExistsWithValidationContext = shouldCheckExists && checkExists;
        return schema
            .validate(email, {
            context: {
                checkExists: false,
                backendEmailValidationEnabled: backendEmailValidationEnabledContext,
                checkExistsWithValidation: checkExistsWithValidationContext,
                regularCheck: !backendEmailValidationEnabledContext && !checkExistsWithValidationContext,
            },
        })
            .then(() => undefined)
            .catch(error => error.message);
    };
    const handleEmailChange = (email) => {
        if (skipValidationFor && email === skipValidationFor) {
            setSkipEmailValidation(true);
        }
        else {
            skipEmailValidation && setSkipEmailValidation(false);
        }
    };
    const handleAcceptClick = () => {
        setEmailStatus(`${common_types_1.EmailValidationResponseStatus.VALID}_${suggestedEmail}`);
        setFieldValue(emailFieldKey, suggestedEmail, true);
    };
    const handleIgnoreClick = () => setSkipEmailValidation(true);
    const renderError = (msg, textProps) => ((0, jsx_runtime_1.jsx)(cotopaxi_1.Text, Object.assign({}, textProps, { children: (0, jsx_runtime_1.jsx)(EmailError_1.EmailError, { emailStatus: msg, suggestedEmail: suggestedEmail, requiredErrorLabel: t('account:delivery.required'), onAcceptClick: handleAcceptClick, onIgnoreClick: handleIgnoreClick }) })));
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [children({
                validate: isCollapsedForm && isEqualValue ? undefined : handleEmailValidation(!isSubmitting),
                renderError,
            }), (0, jsx_runtime_1.jsx)(EmailChangeHandler_1.EmailChangeHandler, { emailFieldKey: emailFieldKey, emailValue: (0, formik_1.getIn)(values, emailFieldKey), skipEmailValidation: skipEmailValidation, onEmailChange: handleEmailChange, setEmailStatus: setEmailStatus })] }));
};
exports.EmailValidationWrapper = EmailValidationWrapper;
